import React from 'react';

import Modal from 'react-modal';
import styles from './contact.module.css';

const customStyles = {
  overlay: {
    background            : 'rgba(0,0,0, .4)',
  },
  content : {
    padding               : '10%',
    top                   : '40%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

class Contact extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    }

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({modalOpen: !this.state.modalOpen})
  }

  render() {
    const type = this.props.type === 'top' ? styles.top : styles.bottom;

    return (
      <div onClick={this.toggleModal} className={`${styles.wrapper} ${type}`}>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >

          <div className={styles.modalContent}>
            <div className={styles.email}>
              <div className={styles.header}>
                Email:
              </div>
                augustvontrapp@gmail.com
            </div>
            <div className={styles.phone}>
              <div className={styles.header}>
                Phone:
              </div>
              +1 971 407 0592
            </div>
            <div className={styles.phone}>
              <div className={styles.header}>
                twitter:
              </div>
              @AugustvonTrapp
            </div>
          </div>
        </Modal>



        <div className={styles.text}>
          Contact
        </div>
      </div>
    )
  }
}

export default Contact;